module.exports = __webpack_public_path__ + "img/dcim06.8673a559.jpg";